import TrackingPixels from './tracking-pixels.plugin-component';
export default TrackingPixels;